import { useTranslation } from 'react-i18next';
import { baseLang } from '../i18n/index.js';

export function Erstgespraech() {
  const { t, i18n } = useTranslation();
  const showNotice = baseLang(i18n.language) !== 'de';
  return (
    <div className="card card-wide">
      {showNotice && <div className="alert alert-info">{t('legalNotice.deAuthoritative')}</div>}
      <h2 className="card-title">Hinweise zum 30-Minuten-Erstgespräch</h2>
      <p className="card-subtitle">
        Diese Hinweise gelten für Online-Termine über die Buchungsseite von
        RA&nbsp;Moritz Quecke / GQL Gussone Quecke Legal.
      </p>

      <h3 className="legal-h">1. Charakter des Gesprächs</h3>
      <p>
        Das Erstgespräch dient dem unverbindlichen Kennenlernen und der Prüfung,
        ob und wie wir Ihnen anwaltlich helfen können. Die Buchung allein begründet
        <strong> kein Mandatsverhältnis</strong>. Ein Mandat kommt erst durch beiderseits
        unterzeichneten Mandatsvertrag oder ausdrückliche Auftragserteilung
        zustande.
      </p>

      <h3 className="legal-h">2. Vergütung</h3>
      <p>
        Das Erstgespräch in dem hier gebuchten Rahmen (30 Minuten Online) ist
        für Sie <strong>kostenfrei</strong>. Eine anwaltliche Beratung im Sinne
        des § 34 RVG findet im Erstgespräch nur dann statt, wenn Sie dies
        ausdrücklich wünschen; sie wird in diesem Fall vorab nach den Sätzen des
        Rechtsanwaltsvergütungsgesetzes (RVG) abgerechnet, gedeckelt auf
        höchstens 190&nbsp;€ zzgl. USt.&nbsp;(§&nbsp;34 Abs.&nbsp;1 S.&nbsp;3 RVG).
        Jede weitergehende anwaltliche Tätigkeit erfolgt ausschließlich
        auf Grundlage eines schriftlichen Mandatsvertrags und wird gesondert
        nach RVG oder Vergütungsvereinbarung berechnet.
      </p>

      <h3 className="legal-h">3. Vertraulichkeit</h3>
      <p>
        Bereits im Erstgespräch unterliegen alle Informationen, die Sie uns
        anvertrauen, der anwaltlichen Verschwiegenheitspflicht
        (§&nbsp;43a Abs.&nbsp;2 BRAO, §&nbsp;203 StGB). Die Verschwiegenheit
        besteht unabhängig davon, ob es zur Mandatsannahme kommt.
      </p>

      <h3 className="legal-h">4. Konfliktprüfung</h3>
      <p>
        Wir prüfen vor jedem Mandat, ob ein anwaltlicher Interessenkonflikt
        besteht (§&nbsp;43a Abs.&nbsp;4 BRAO, §&nbsp;3 BORA). Sollte ein solcher
        bestehen, müssen wir das Erstgespräch ggf. beenden und können kein
        Mandat übernehmen.
      </p>

      <h3 className="legal-h">5. Technische Durchführung</h3>
      <p>
        Das Gespräch findet als Microsoft-Teams-Besprechung statt. Den
        Einladungslink erhalten Sie unmittelbar nach der Buchung per E-Mail.
        Die Bereitstellung erfolgt über Microsoft&nbsp;365; auf die
        Datenschutzerklärung dieses Online-Onboarding-Portals
        (<a href="/datenschutz">/datenschutz</a>) wird verwiesen.
      </p>

      <h3 className="legal-h">6. Stornierung / Verschiebung</h3>
      <p>
        Bitte sagen Sie Termine, die Sie nicht wahrnehmen können, möglichst
        <strong> bis 24 Stunden vorher</strong> ab. Eine Stornierung ist über
        den Link in der Bookings-Bestätigungsmail jederzeit möglich.
      </p>

      <h3 className="legal-h">7. Sicherheitshinweis</h3>
      <p>
        Falls Sie eine besondere Eilbedürftigkeit haben (z.&nbsp;B. drohende
        Fristen innerhalb der nächsten 48 Stunden), nutzen Sie bitte
        <strong> nicht ausschließlich</strong> die Online-Buchung, sondern
        rufen Sie uns zusätzlich an: <a href="tel:+493091519940">+49&nbsp;30 9151 9940</a>.
      </p>

      <p style={{ marginTop: 28, fontSize: '0.85em' }}>
        Stand: 27.05.2026 · GQL Gussone Quecke Legal Partnerschaft von Rechtsanwälten mbB ·
        <a href="/impressum"> Impressum</a> · <a href="/datenschutz">Datenschutz</a>
      </p>
    </div>
  );
}
